export default "__VITE_ASSET__gexdfpsC__"